import type {
  RatingSlots as RatingBaseSlots,
  RatingBaseProps,
  RatingBaseState,
  RatingContextValues as RatingContextValuesBase,
} from '@fluentui/react-rating';

/**
 * Rating component slots
 */
export type RatingSlots = RatingBaseSlots;

/**
 * Rating component props
 */
export type RatingProps = RatingBaseProps;

/**
 * Rating component state
 */
export type RatingState = RatingBaseState;

/**
 * Rating component context values
 */
export type RatingContextValues = RatingContextValuesBase;
